
<template>
    <div>
        <label>
            Rows per page
            <select v-model.number="each" v-on:change="query( { each } )">
                <option v-for="value in options">{{ value }}</option>
            </select>
        </label>

        <span class="divider">page {{ paginator.page }} of {{ paginator.pages }}</span>

        <div class="buttons">
            <button v-if="paginator.page !== 1" v-on:click="query( { page: paginator.page -1 } )" class="button">Previous</button>
            <button v-else class="button">Previous</button>

            <button v-if="paginator.page !== paginator.pages" v-on:click="query( { page: paginator.page +1 } )" class="button">Next</button>
            <button v-else class="button">Next</button>
        </div>
    </div>
</template>

<script>
	import Paginator from '../support/Paginator';

	export default
    {
    	data()
        {
        	const options = [];
        	for( let i = 1; i !== 4; ++i )
        		options.push( Paginator.each * i );

            return {
	            each: this.paginator.each,
                options,
            };
        },
        methods:
        {
    	    query( attributes )
            {
            	const query = { ...this.$route.query };

                // add page query string where page is not equal to one
	            if( attributes.page !== query.page ) {
	            	if( attributes.page !== 1 ) {
	            		query.page = attributes.page;
                    } else delete query.page;
	            }

	            // add records per page query string where records is not equal to default
	            if( attributes.each && attributes.each !== query.each ) {
		            if( attributes.each !== Paginator.each ) {
			            query.each = attributes.each;
		            } else delete query.each;

		            if( query.page ) {
			            const pages = Math.ceil( this.paginator.length / ( query.each || Paginator.each ) );
			            if( query.page > pages && pages === 1 ) {
				            delete query.page;
			            } else query.page = pages;
		            }
	            }

                this.$router.replace( { name: this.$route.name, query } );
            },
        },
	    props: {
    		paginator: {
                required: true,
                type: Paginator,
            },
        },
	};
</script>
